import { FormattedPercentage } from 'I18n/utils/internal/light/numberFormatters';
import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersPercentageValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const {
    name,
    value,
    highValue
  } = condition;
  const label = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `customerDataFiltersUI.quickFilters.filterOperatorTranslations.DURATION_NUMBER.${name}`,
    options: {
      value: /*#__PURE__*/_jsx(FormattedPercentage, {
        precision: 2,
        stripInsignificantZeros: true,
        value: Number(value) * 100
      }),
      highValue: /*#__PURE__*/_jsx(FormattedPercentage, {
        precision: 2,
        stripInsignificantZeros: true,
        value: Number(highValue) * 100
      })
    }
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: name,
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersPercentageValueDisplay;